module.exports = __webpack_public_path__ + "img/blog-17-2.1bf47d08.webp";